import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-continue-form-page',
    templateUrl: './continue-form-page.component.html',
    styleUrls: ['./continue-form-page.component.css'],
    standalone: false
})
export class ContinueFormPageComponent {
  @Input() formattedMaskedValue: string = '';
  @Input() expiryDate: string = '';
  @Input() phoneNumber: string | null = null;
  @Input() error: boolean = false;

  @Output() actionTriggered = new EventEmitter<boolean>();

  constructor() {}

  triggerAction(continueProcess: boolean) {
    this.actionTriggered.emit(continueProcess);
  }
}
